<template>
    <MainPage @clickBack="clickBack()">
        <div class="max-w-xl m-auto" v-if="isInit">
            <div class="pt-4 px-4">
                <InputSearch
                    v-model:inputValue="promoCode"
                    :errorInfo="formErrorInfo[0]"
                    :isSubmitted="isSubmitted"
                    :isShowError="isShowError"
                    :inputLbl="lbl.coupon.promocode"
                    @onEnter="SearchPromoCode()"
                    @onChange="onChangeSearch()"
                ></InputSearch>
            </div>
            <div v-show="!ispromoCode">
                <div class="grid grid-cols-2 mb-4 border-b border-a-brown-d7c7b8">
                    <div :class="getTabClass(0)" @click="clickTab(0)">{{lbl.coupon.all_coupon}}</div>
                    <div :class="getTabClass(1)" @click="clickTab(1)">{{lbl.coupon.my_coupon}}</div>
                </div>
                <div v-show="tabActive == 0">
                    <CouponList
                            ref="campaign-list"
                            :initListConfig="listConfig"
                            :initFilterConfig="filterConfig"
                            @onLoaded="onLoadSuccess('campaign')"
                    ></CouponList>
                </div>
                <div v-show="tabActive == 1">
                    <MyCouponList
                            ref="mycoupon-list"
                            @onLoaded="onLoadSuccess('mycoupon')"
                    ></MyCouponList>
                </div>
            </div>
            <div v-if="ispromoCode && !isEmptry && objPromoCode">
                <PromoCode
                    :objPromoCode="objPromoCode"
                ></PromoCode>
            </div>
            <div v-if="ispromoCode && isEmptry">
                <div class="text-14 lg:text-16 text-center text-a-brown-9f8273">Sorry, the code you’ve entered is fully redeemed or invalid.</div>
            </div>
        </div>
    </MainPage>
</template>
<script>
// helper
import { FormHelper } from '@/helper/FormHelper.js';
import ConfigManager from '@/config/ConfigManager.js';
//component
import InputSearch from "@/components/Input/label/InputSearch.vue";
import MainPage from "@/components/Layout/Page/MainPage.vue";
import CouponList from '../component/CouponList.vue';
import MyCouponList from '../component/MyCouponList.vue';
import PromoCode from '../component/PromoCode.vue';
//service
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";
import BzbsCoupon from "@/core/Coupon/service/BzbsCoupon";
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import DeliveryMixin from '@/mixin/DeliveryMixin.js';
export default {
    name: 'Coupon',
    mixins: [ModalMixin,LocaleMixin,DeliveryMixin],
    components: {
        MainPage,
        InputSearch,
        CouponList,
        MyCouponList,
        PromoCode
    },
    data: function() {
        return {
            tabActive: 0, // 0, 1
            isInit: false,

            couponConfig: null,
            myCouponConfig: ConfigManager.getCouponConfigList(),

            listConfig: null,
            filterConfig: null,

            loadingStatus: {
                campaign: false,
                mycoupon: false
            },

            formErrorInfo: [],
            isSubmitted: false,
            isShowError: false,

            promoCode: "",
            ispromoCode: false,
            isEmptry: false,
            objPromoCode: null,
        };
    },
    created: function() {
        this.setScrollLoadMore();
        this.initialConfig();
        this.formErrorInfo = FormHelper.genErrorInfo(1);
    },
    mounted: function() {
        this.modal.loadingModal.show();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        onDeliveryUpdate: function() {
            this.initialConfig()
        },
        initialConfig: function() {
            if (this.delivery) {
                if (this.delivery.deliveryMethod == "Delivery") {
                    this.couponConfig = ConfigManager.getCouponDeliveryConfigList()
                } else {
                    this.couponConfig = ConfigManager.getCouponPickupConfigList()
                }
            
                var listConfig = new CampaignListConfigBuilder()
                    .setConfigList(this.couponConfig)
                    .setTop(25)
                    .create();
                this.listConfig = listConfig;

                var filterConfig = new CampaignListFilterConfigBuilder().create();
                this.filterConfig = filterConfig;

                this.isInit = true
            }
        },

        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow && this.isInit) {
                    this.loadMore();
                }
            };
        },

        loadMore: function() {
            this.$refs['campaign-list'].loadMore();
        },

        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.modal.loadingModal.hide();
                }
            }
        },
        SearchPromoCode: async function() {
            console.log("SearchPromoCode", this.promoCode)
            this.modal.loadingModal.show();
            this.promoCodeEmptry = false;
            this.ispromoCode = true;
            await this.apiVerifyPromocode()
        },
        apiVerifyPromocode: function() {
            return new Promise((resolve) => {
                BzbsCoupon.verifyPromocode(this.promoCode).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.objPromoCode = data;
                        this.objPromoCode.setCode(this.promoCode);
                        this.isEmptry = false;
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);

                        if (err.code == "404") {
                            this.isEmptry = true;
                        } else {
                            this.errorApi(err);
                        }
                        
                    },
                });
            });
        },
        onChangeSearch: function() {
            if (this.promoCode == "") {
                this.ispromoCode = false;
                this.objPromoCode = null;
            }
        },
        getTabClass: function(tab) {
            if (tab == this.tabActive) {
                return 'py-2 font-bold border-b-4 border-a-red-d62300 text-a-red-d62300 text-14 lg:text-16 text-center cursor-pointer';
            }
            return 'py-2 text-14 lg:text-16 font-bold text-a-brown-502314 text-center cursor-pointer';
        },
        clickTab: function(tab) {
            this.tabActive = tab;
        },
        clickBack: function() {
            this.$router.back();
        }
    },
}
</script>
<style lang="scss" scoped>
    .wrapper-input {
        height: 50px;
    }
</style>
